import React, {useEffect, useState} from "react";
import SimpleLineIcon from "react-simple-line-icons";
import "./VerifyCustomer.scss";
import {useLocation,useHistory} from "react-router";
import {fixNumbers, MessageHandler, Validation, VerifyRequest} from "../../Services";
import {isMobile} from "react-device-detect";
import ReactGA from 'react-ga';
import {useDispatchUser, useUser} from "../../hooks";

function VerifyCustomer() {

    //hooks
    const location = useLocation();
    const history = useHistory();
    const setUser = useDispatchUser();


    // states
    const [code,setCode] = useState("");
    const [token,setToken] = useState("");
    const [factor,setFactor] = useState("");
    const [verifyState,setVerifyState] = useState(false);
    const [btnState,setBtnState] = useState(true);



    useEffect(()=>{
        // console.log("Loc : ",location.state)
        if(location.state && location.state.token){
            setToken(location.state.token)
        }

        if(location.state && location.state.factorId){
            setFactor(location.state.factorId)
        }

        history.replace('/verify-customer',{...location.state,token:null,factorId:null});
    },[])




    // Login Method -------------------------------------------------------------------
    const Verify_Request = async () => {

        // pre request
        setVerifyState(true);


        if (!Validation({type:"VERIFY_TOKEN",val:fixNumbers(code)})){
            MessageHandler({type:"VALIDATION",status:"VERIFY_CODE"})
            setVerifyState(false);
            return ;
        }

        if (token.length<1){
            MessageHandler({type:"VALIDATION",status:"VERIFY_TOKEN"})
            setVerifyState(false);
            return ;
        }

        //request
        try{
            let response = await VerifyRequest({code:fixNumbers(code),token:token})
            //post success request
            setVerifyState(false);
            //MessageHandler({type:"LOGIN",status:"SUCCESS"})

            //set Token to localstorage
            localStorage.setItem('token',response.data.access_token);

            //User Set
            localStorage.setItem('user',JSON.stringify(response.data));
            setUser(response.data);
            //set User GA
            // ReactGA.initialize('UA-175496552-1', {
            //     debug: false,
            //     titleCase: false,
            //     gaOptions: {
            //         userId: 123,
            //         clientId: response.data.phone
            //     }
            // });
            //ReactGA.set({userId:response.data.phone})
            history.push('/customer/factor',{factorId:factor})
        }catch (e) {
            //post failed request
            setVerifyState(false);
            MessageHandler({type:"VALIDATION",status:"VERIFY_TOKEN"})
        }
    }

    const updateWindowDimensions = () => {
        if(window.innerHeight<380){
            setBtnState(false)
        }else {
            setBtnState(true)
        }
    }

    useEffect(()=>{
        window.addEventListener('resize',updateWindowDimensions);
        return () => {window.addEventListener('resize',updateWindowDimensions)}
    },[])

    const onEnter = (event, callback) => event.key  === 'Enter' && callback()
    const enterEvent = () => Verify_Request();

    return(
        <div className="otp-container">
            <div className="otp-logo">
                <img src="/other/logo.png" alt="Digi Mall"/>
            </div>
            <div className="otp-message">
                <div className="otp-message">
                    <span>را وارد کنید</span>
                    <span>لطفا کد فعالسازی ارسال شده  </span>
                </div>
            </div>

            <div className="otp-input">
                <input
                    value={code}
                    onFocus={()=>{if(isMobile){setBtnState(false)}}}
                    onBlur={()=>{setTimeout(()=>{setBtnState(true)},100)}}
                    onChange={(e)=>{setCode(e.target.value)}}
                    onKeyPress={e => onEnter(e, enterEvent)}
                    type="text" name="" id="" placeholder="کد فعال سازی ۶ رقمی"/>
                <SimpleLineIcon name="lock"/>
            </div>


            {btnState?<div className="top-float-send-btn">
                <div className="float-btn" onClick={Verify_Request}>
                    {verifyState?<i className="fa fa-spinner fa-spin"></i>:<i className="fa fa-arrow-left"></i>}
                    ورود
                    <span style={{fontSize:17}}></span>
                </div>
            </div>:null}

        </div>
    )
}

export {VerifyCustomer}
